import React, { useEffect, useState } from 'react';
import LinkifyText from './LinkifyText.js';
import { useParams} from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';

const CourseDetail = () => {
    const { idcourse } = useParams(); // Obtenida de la URL
    const [course, setCourse] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE_URL}/api/details.php?type=course&id=${idcourse}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setError(data.error);
                } else {
                    setCourse(data);
                }
            })
            .catch((error) => setError('Error al obtener los detalles del curso.'));
    }, [idcourse]);

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}-${month}-${year}`;
    };

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!course) {
        return <div>Cargando detalles del curso...</div>;
    }

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <div className="card" style={{ maxWidth: '900px', margin: '20px auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div className="card-body m-2">
                <h1 className="card-title">{course.title}</h1>
                <img
                    src={course.img_url 
                            ? `${API_BASE_URL}/public/uploads/images/${course.img_url}` // Para desarrollo -> `http://localhost/ligaincom/uploads/${course.img_url}` 
                            : `${API_BASE_URL}/public/uploads/images/comic.jpg`}  // copiar también la ruta de images
                    alt={course.img_alt || 'Imagen del curso'}
                    style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', marginBottom: '20px', marginLeft: '-2%' }}
                />
                <LinkifyText text={course.body} />
                
                {course.location && (
                    <p className="card-text">
                        <strong>Ubicación:</strong> {course.location || 'No especificada'}
                    </p>
                )}
                
                {course.day && course.day !== '0000-00-00' && (
                    <p className="card-text">
                        <strong>Fecha:</strong> {formatDate(course.day)}
                    </p>
                )}

                {course.hour && course.hour !== '00:00:00' && (
                    <p className="card-text">
                        <strong>Hora:</strong> {course.hour || 'No especificada'}
                    </p>
                )}

                <button
                    className="btn btn-primary"
                    style={{ marginTop: '20px', padding: '10px 20px', backgroundColor: '#005EC4', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
                     onClick={scrollToTop}
                >
                    Subir
                </button>
            </div>
        </div>
    );
};

export default CourseDetail;
